import React, { useContext, useEffect } from 'react'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import { allLanguages } from 'config/localisation/languageCodes'
import { LanguageContext } from 'contexts/Localisation/languageContext'
import useTheme from 'hooks/useTheme'
import { usePricePRV2Busd,usePricePRVGBusd,usePriceCakeBusd } from 'state/hooks'
import { Menu as UikitMenu } from '@pancakeswap-libs/uikit'
import config from './config'

const Menu = (props) => {
  const { account, connect, reset } = useWallet()
  const { selectedLanguage, setSelectedLanguage } = useContext(LanguageContext)
  const { isDark, toggleTheme } = useTheme()
  const cakePriceUsd = usePriceCakeBusd()
  const prv2Price = usePricePRV2Busd()
  const prvgPrice = usePricePRVGBusd()


  useEffect(()=>{
    console.log("wsaaa",{prvgPrice,prv2Price})
  },[prvgPrice,prv2Price])

  return (
    <UikitMenu
      account={account}
      login={connect}
      logout={reset}
      isDark={isDark}
      toggleTheme={toggleTheme}
      currentLang={selectedLanguage && selectedLanguage.code}
      langs={allLanguages}
      setLang={setSelectedLanguage}
      prv2Price={prv2Price}
      prvgPrice={prvgPrice}
      cakePriceUsd={cakePriceUsd.toNumber()}
      links={config}
      priceLink=""
      {...props}
    />
  )
}

export default Menu
